import React from 'react';
import ConnectPage from '../components/ConnectPage';
import { Facebook as FacebookIcon } from '@mui/icons-material';

const MetaConnectPage: React.FC = () => {
  const config = {
    serviceName: 'Meta Ads',
    serviceDisplayName: 'Meta Ads (Facebook)',
    apiBaseUrl: 'https://api.meta.cubehq.ai',
    routePath: '/connect/meta',
    buttonGradient: 'linear-gradient(45deg, #0062E0, #19AFFF)',
    buttonHoverGradient: 'linear-gradient(45deg, #0058c9, #179de6)',
    connectIcon: <FacebookIcon />,
    backendOAuthPath: '/oauth/meta',

    storageKeys: {
      email: 'metaUserEmail',
      returnUrl: 'metaMcpReturnUrl',
      clientId: 'metaMcpClientId',
      state: 'metaMcpState',
      redirectUri: 'metaMcpRedirectUri',
      codeChallenge: 'metaMcpCodeChallenge',
    },
    messages: {
      requestAccess: 'Claude is requesting access to your Meta Ads data. Click "Connect" to authenticate.',
      directAccessError: 'This page is only accessible through Claude AI. Please add the Meta Ads connector in Claude to authenticate.',
      connectDescription: 'Connect your Meta Ads account to access your campaigns and data through Claude AI.',
      connectingMessage: 'Connecting...',
      successMessage: 'Successfully connected to Meta Ads!',
      errorMessage: 'Failed to connect to Meta Ads. Please try again.',
      buttonText: 'Connect Your Meta Ads Account',
    },
  };
  
  return <ConnectPage config={config} />;
};

export default MetaConnectPage;